import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import portadaInicio from "../assets/img/portada-inicio.jpg";
import ModalTerminosYCondiciones from '../components/ModalTerminosYCondiciones'

export default function Inicio() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <img src={portadaInicio} id="top" alt="portada inicio" className="w-100 pt-5 col-12" />
      <div className="container bg-secondary">
        <div className="row">
          <div className="py-2">
            <div className="col-12 pt-3 text-center text-white">
              <strong style={{ fontSize: '14px' }}>FUNDACIÓN OBRA</strong>
              <p className="text-white claseFuente">
                "Yo Soy La Inmaculada Madre del Divino Corazón Eucarístico de
                Jesús"
              </p>
              <strong style={{ fontSize: '14px' }}>y OBRA</strong>
              <p className="text-white claseFuente">
                "Yo Soy El Sacratísimo Corazón <br /> Eucarístico de Jesús"
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="comunicado py-4 bg-primary text-center">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 mt-4 pb-5 mb-lg-0">
              <h2 className="text-uppercase mb-4 text-white">
                Señor peregrino
              </h2>
              <p className="mb-0 text-white">
                Si usted desea mayor información puede visitar nuestra página
                web
              </p>
              <a
                className="text-white text-underline"
                target="_blank"
                rel="noreferrer"
                href="http://www.inmaculadamadre-salta.org/obra/"
              >
                <button className="btn-comunicado text-center">
                  <i className="bi bi-globe me-1"></i> <strong>www.inmaculadamadre-salta.org</strong>
                </button>
              </a>
              <p className="my-4 text-white mail-a">Nuestro canal de Youtube:</p>
              <a
                href="https://www.youtube.com/channel/UCdfYG67PVUM_tReog4YB7Lw"
                className="text-white text-underline"
                target="_blank"
                rel="noreferrer"
              >
                <button className="btn-comunicado text-center">
                  <i className="bi bi-youtube me-1"></i> <strong>Obra Inmaculada Madre - IMCEJ y SACEJ</strong>
                </button>
              </a>
              <p className="my-4 text-white mail-a">Para comunicarse por correo:</p>
              <a
                href="mailto:consultas@inmaculadamadre-salta.org?subject="
                className="text-white text-underline"
                target="_blank"
                rel="noreferrer"
              >
                <button className="btn-comunicado text-center">
                  <i className="bi bi-at me-1"></i> <strong>consultas@inmaculadamadre-salta.org</strong>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-per bg-secondary">
        <div className="container">
          <div className="row">
            <h5 className="col-12 mb-4 text-white">
              Hecho el depósito de La Ley 11.723
            </h5>
            <p>
              Pertenece a la Fundación Obra: Yo Soy La Inmaculada Madre Del
              Divino Corazón Eucarístico De Jesús y Obra: Yo Soy El Sacratísimo
              Corazón Eucarístico de Jesús.
            </p>
            <p className="py-3">
              <strong>Sitio Oficial:</strong>
              <a
                href="http://www.inmaculadamadre-salta.org/obra/"
                target="_blank"
                rel="noreferrer"
                alt=""
              >
                www.inmaculadamadre-salta.org
              </a>
            </p>
            <p>
              <strong>Canal oficial Youtube:</strong> <br /> Obra Inmaculada
              Madre - IMCEJ y SACEJ
            </p>
            <p className="py-3">
              <strong>Teléfono:</strong>
              <a href="tel:+543874390030">0387 - 4390030</a>
            </p>
            <h6 className="col-12">DISTRIBUCIÓN GRATUITA</h6>
            <p className="terminos-condiciones" onClick={handleShow}> Ver Términos y Condiciones </p>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose}>
        <ModalTerminosYCondiciones handleClose={handleClose} />
      </Modal>
    </>
  );
}
